<template>
  <div>
    <div class="main-title marTop64">
      咨询分类
    </div>
    <div class="main-cates">
      <div class="block" zz-sortid="0" zz-sortname="商城（购买）" @click="enterPage(1)">
        <div class="title">商城（购买）</div>
        <div class="desc">手机 iPad 手表 笔记本</div>
      </div>
      <div class="block" zz-sortid="1" zz-sortname="靓选（购买）" @click="enterPage(2)">
        <div class="title">靓选（购买）</div>
        <div class="desc">3C周边 充电器 充电宝</div>
      </div>
      <div class="block verdict" zz-sortid="2" zz-sortname="趣租机（租赁）" @click="enterPage(3)">
        <div class="title">趣租机（租赁）</div>
        <div class="desc">出租：手机 手表 等</div>
      </div>
      <div class="block verdict" zz-sortid="3" zz-sortname="回收" @click="enterPage(4)">
        <div class="title">回收</div>
        <div class="desc">回收：手机 手表 笔记本 等</div>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'

export default {
  name: 'QuestionCategorySeller',
  methods: {
    enterPage(type) {
      let url = ''

      if (type === 1) {
        url = 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_sc'
      } else if (type === 2) {
        url = 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_lx'
      } else if (type === 3) {
        url = 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_qzj'
      } else if (type === 4) {
        url = 'https://feentry.zhuanzhuan.com/zlj?clientid=cs_hs'
      }

      native.skipToUrl({
        targetUrl: url
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../HelpCenter.less';
  @import 'QuestionCategory.less';
</style>
